export default __webpack_public_path__ + "static/media/edificio.af1f16b3.svg";